import GuestAccordion from './GuestAccordion'

export default GuestAccordion
